import { Terminal } from '@payment-terminals/interfaces/terminal';

import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CashdroService from '@pos/services/cashdro-service';
import CashdroLevelsTable from '@payment-terminals/components/tables/cashdro-levels-table/cashdro-levels-table.vue';
import { faCashRegister } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import CashdroErrorHelper from '@pos/helpers/cashdro-error-helper';

library.add(faCashRegister);

@Component({
  name: 'bpc-cashdro-terminal-payment-modal',
  components: { 'bpc-cashdro-levels-table': CashdroLevelsTable },
})
export default class CashdroTerminalPaymentModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'payment_terminals.modal.pay_with_cashdro' })
  readonly modalTitle: string;
  @Prop({ type: Number, default: 0 }) readonly payAmount: number;
  @Prop(Number) readonly invoiceId: number;
  @Prop(Number) readonly contactId: number;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly terminals: Terminal[];
  selectedTerminal: Terminal = null;

  blockBtnClose: boolean = false;

  //  DATA to check terminal status:
  public terminalStatus: boolean = null;
  public paymentInProgess: boolean = false;
  public paymentProcessed = false;
  public paymentErrorMsg: string = '';
  readonly paymentSuccessMsg: string = 'payment_terminals.cashdro.success_payment_message';
  readonly paymentCreatedMsg: string =
    'payment_terminals.cashdro.success_message.cashdro_payment_created';
  public paymentErrorReason: string = '';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public paymentErrorData: any = {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public pendingOperation: any = {};

  public refreshingOperationStatus: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onGoingOperation: any = {};
  public showTerminalLevels: boolean = false;
  public refreshInterval;
  public terminalLevels = [];

  get availableTerminals() {
    return this.terminals.map(terminal => {
      return {
        text: `[${terminal.device_id}] ${terminal.name}`,
        value: terminal,
      };
    });
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get isOperationWithNoChangeAvailable(): boolean {
    return (
      this.paymentErrorReason ===
      'cashdro_operation_with_amount_change_not_available_error_exception'
    );
  }

  get operationWithNoChangeAvailable() {
    return !this.isEmpty(this.onGoingOperation) ? this.onGoingOperation : this.pendingOperation;
  }

  get pendingOperationInExecution(): boolean {
    if (
      this.paymentErrorReason === 'cashdro_operations_in_execution_exception' ||
      this.paymentErrorReason === 'cashdro_operation_with_error_exception'
    ) {
      return true;
    }
    return false;
  }

  get operationIsNotInExecution(): boolean {
    if (
      this.paymentErrorReason === 'cashdro_operation_is_not_in_execution_exception' ||
      this.paymentErrorReason === 'cashdro_service_stopped_exception' ||
      // this.paymentErrorReason === 'cashdro_invalid_parameters_exception' ||
      this.paymentErrorReason === 'cashdro_can_not_start_operation_exception' ||
      this.paymentErrorReason === 'cashdro_system_busy_exception'
    ) {
      return true;
    }
    return false;
  }

  get hasTerminalCorrectCashLevels(): boolean {
    return this.paymentErrorReason !== 'cashdro_unit_terminal_with_alerts';
  }

  get terminalLevelsWithErrors() {
    return this.terminalLevels.filter(level => level.State !== '-1');
  }

  get levelAlertsMsg(): string {
    const errorHelper = new CashdroErrorHelper();
    return errorHelper.cashdroUnitTermilansWithAlersError().msg;
  }

  async mounted() {
    if (this.terminals.length === 1) {
      this.selectedTerminal = this.terminals[0];
      await this.makePayment();
    }
  }

  moneyWithComma(amount) {
    return String(amount).replace('.', ',');
  }

  initVars() {
    this.paymentInProgess = true;
    this.terminalStatus = false;
    this.paymentErrorMsg = '';
    this.paymentErrorReason = '';
    this.paymentErrorData = {};
  }

  changeSelectedTerminalId(terminal: Terminal) {
    this.selectedTerminal = terminal;
  }

  async makePayment() {
    console.log('== makePayment ==');
    this.blockBtnClose = true;
    this.pendingOperation = {};
    this.onGoingOperation = {};
    this.terminalLevels = [];
    this.initVars();

    const cashdroService = new CashdroService();
    const terminalLevelsResponse = await cashdroService.getTerminalLevels(this.selectedTerminal);
    console.log('-- terminalLevelsResponse --');
    console.log(terminalLevelsResponse);

    if (terminalLevelsResponse.ok()) {
      this.terminalLevels = terminalLevelsResponse.getResult().content.operation.pieces;
    }

    const loggedContactId = this.$authorizationService.getContactId();
    const paymentResponse = await cashdroService.makePayment(
      this.selectedTerminal,
      this.payAmount,
      this.invoiceId,
      loggedContactId,
    );
    console.log('-- paymentResponse --');
    console.log(paymentResponse);
    console.log('-- paymentResponse.getResult --');
    console.log(paymentResponse.getResult());

    if (paymentResponse.ok()) {
      this.terminalStatus = paymentResponse.ok();
      this.paymentInProgess = false;
      this.blockBtnClose = false;
      this.paymentProcessed = true;
      this.onGoingOperation = paymentResponse.getResult().content.operation;
      console.log(this.onGoingOperation);
      this.$emit('payment-created');
      this.refreshInterval = setInterval(() => {
        if (
          (this.onGoingOperation && this.onGoingOperation.state === 'E') ||
          (this.onGoingOperation && this.onGoingOperation.state === 'F')
        ) {
          this.refreshOnGoingOperationStatus();
        } else {
          clearInterval(this.refreshInterval);
        }
      }, 5000);
    } else {
      this.terminalStatus = false;
      this.paymentInProgess = false;
      this.paymentErrorMsg = paymentResponse.getResult().error.msg;
      this.paymentErrorReason = paymentResponse.getResult().error.reason;
      this.paymentErrorData = paymentResponse.getResult().content;
      if (!this.hasTerminalCorrectCashLevels) {
        this.showTerminalLevels = true;
        this.terminalLevels = paymentResponse.getResult().content.operation.pieces;
      } else {
        this.pendingOperation = paymentResponse.getResult().content.operation;
      }

      this.blockBtnClose = false;
      this.paymentProcessed = true;
    }
  }

  /* NOTE: current operation */
  async refreshOnGoingOperationStatus() {
    console.log('== refreshOnGoingOperationStatus ==');
    console.log('-- onGoingOperation --');
    console.log(this.onGoingOperation);
    this.blockBtnClose = true;
    this.refreshingOperationStatus = true;
    const cashdroService = new CashdroService();
    if (this.onGoingOperation.state === 'E') {
      const getOperationStatusResponse = await cashdroService.getOperationStatus(
        this.selectedTerminal,
        this.onGoingOperation.operationId,
      );
      console.log('-- getOperationStatusResponse --');
      console.log(getOperationStatusResponse);
      console.log('-- getOperationStatusResponse.getResult --');
      console.log(getOperationStatusResponse.getResult());

      if (getOperationStatusResponse.ok()) {
        this.terminalStatus = getOperationStatusResponse.ok();
        this.paymentInProgess = false;
        this.refreshingOperationStatus = false;
        this.onGoingOperation = getOperationStatusResponse.getResult().content.operation;
      } else {
        this.terminalStatus = false;
        this.paymentInProgess = false;
        this.paymentErrorMsg = getOperationStatusResponse.getResult().error.msg;
        this.paymentErrorReason = getOperationStatusResponse.getResult().error.reason;
        this.paymentErrorData = getOperationStatusResponse.getResult().content;
        if (this.isOperationWithNoChangeAvailable) {
          this.onGoingOperation = getOperationStatusResponse.getResult().content.operation;
          clearInterval(this.refreshInterval);
          this.endOperation();
          this.$emit('payment-finalized');
          this.close();
        }
        console.log(getOperationStatusResponse);
        clearInterval(this.refreshInterval);
      }
    } else if (this.onGoingOperation.state === 'F') {
      /* NOTE: this parameter does not appear in the official documentation but it seems that 4 is completed and 2 is cancelled. */
      if (this.onGoingOperation.finalStatus === 4) {
        clearInterval(this.refreshInterval);
        this.close();
      }

      if (this.onGoingOperation.withError === false) {
        clearInterval(this.refreshInterval);
        this.endOperation();
      } else {
        alert('error with "F" operation');
      }
    }
  }
  /* NOTE: pending operation */
  async refreshPendingOperationStatus() {
    console.log('== refreshPendingOperationStatus ==');
    console.log('-- pendingOperation --');
    console.log(this.pendingOperation);
    this.blockBtnClose = true;
    this.refreshingOperationStatus = true;
    const cashdroService = new CashdroService();

    if (this.pendingOperation.state === 'E') {
      const getOperationStatusResponse = await cashdroService.getOperationStatus(
        this.selectedTerminal,
        this.pendingOperation.operationId,
      );
      console.log('-- getOperationStatusResponse --');
      console.log(getOperationStatusResponse);
      console.log('-- getOperationStatusResponse.getResult --');
      console.log(getOperationStatusResponse.getResult());
      if (getOperationStatusResponse.ok()) {
        this.terminalStatus = false;
        this.paymentInProgess = false;
        this.refreshingOperationStatus = false;
        this.pendingOperation = getOperationStatusResponse.getResult().content.operation;
      } else {
        this.terminalStatus = false;
        this.paymentInProgess = false;
        this.paymentErrorMsg = getOperationStatusResponse.getResult().error.msg;
        this.paymentErrorReason = getOperationStatusResponse.getResult().error.reason;
        this.paymentErrorData = getOperationStatusResponse.getResult().content;
        this.pendingOperation = getOperationStatusResponse.getResult().content.operation;
        if (this.isOperationWithNoChangeAvailable) {
          this.pendingOperation = getOperationStatusResponse.getResult().content.operation;
          this.endPendingOperation();
          this.$emit('payment-finalized');
          this.close();
        }
        console.log(getOperationStatusResponse);
        clearInterval(this.refreshInterval);
      }
    } else if (this.pendingOperation.state === 'F') {
      if (this.pendingOperation.withError === false) {
        clearInterval(this.refreshInterval);
        this.endOperation();
        this.close();
      } else {
        alert('error with "F" operation');
      }
    }
  }

  async cancelPendingOperation() {
    console.log('== cancelPendingOperation ==');
    this.blockBtnClose = true;
    this.initVars();
    clearInterval(this.refreshInterval);

    const cashdroService = new CashdroService();

    const cancelPendingOperationResponse = await cashdroService.cancelOperation(
      this.selectedTerminal,
      this.pendingOperation.operationId,
      this.pendingOperation.posId,
    );
    console.log('-- cancelPendingOperationResponse --');
    console.log(cancelPendingOperationResponse);
    console.log('-- cancelPendingOperationResponse.getResult --');
    console.log(cancelPendingOperationResponse.getResult());

    if (cancelPendingOperationResponse.ok()) {
      this.terminalStatus = cancelPendingOperationResponse.ok();
      this.paymentInProgess = false;
      this.blockBtnClose = false;
      console.log(cancelPendingOperationResponse);
      this.$emit('payment-cancelled');
      this.close();
    } else {
      this.terminalStatus = false;
      this.paymentInProgess = false;
      this.paymentErrorMsg = cancelPendingOperationResponse.getResult().error.msg;
      this.paymentErrorReason = cancelPendingOperationResponse.getResult().error.reason;
      this.paymentErrorData = cancelPendingOperationResponse.getResult().content;
      this.pendingOperation = cancelPendingOperationResponse.getResult().content.operation;
      this.blockBtnClose = false;
      console.log(cancelPendingOperationResponse);
    }
  }

  async cancelOnGoingOperation() {
    console.log('== cancelOnGoingOperation ==');
    this.blockBtnClose = true;
    this.initVars();
    clearInterval(this.refreshInterval);

    const cashdroService = new CashdroService();
    const cancelOperationResponse = await cashdroService.cancelOperation(
      this.selectedTerminal,
      this.onGoingOperation.operationId,
      this.invoiceId,
    );
    console.log('-- cancelOperationResponse --');
    console.log(cancelOperationResponse);
    console.log('-- cancelOperationResponse.getResult --');
    console.log(cancelOperationResponse.getResult());

    if (cancelOperationResponse.ok()) {
      this.terminalStatus = cancelOperationResponse.ok();
      this.paymentInProgess = false;
      this.blockBtnClose = false;
      console.log(cancelOperationResponse);
      this.$emit('payment-cancelled');
      this.close();
    } else {
      this.terminalStatus = false;
      this.paymentInProgess = false;
      this.paymentErrorMsg = cancelOperationResponse.getResult().error.msg;
      this.paymentErrorReason = cancelOperationResponse.getResult().error.reason;
      this.paymentErrorData = cancelOperationResponse.getResult().content;
      this.blockBtnClose = false;
      console.log(cancelOperationResponse);
    }
  }

  async finalizeOnGoingOperation() {
    console.log('== finalizeOnGoingOperation ==');
    this.blockBtnClose = true;
    this.initVars();
    clearInterval(this.refreshInterval);
    const cashdroService = new CashdroService();
    const formatedAmount = this.onGoingOperation.totalin / 100;
    const finalizeOnGoingOperationResponse = await cashdroService.finalizeOperation(
      this.selectedTerminal,
      this.onGoingOperation.operationId,
      this.invoiceId,
      formatedAmount,
    );
    console.log('-- finalizeOnGoingOperationResponse --');
    console.log(finalizeOnGoingOperationResponse);
    console.log('-- finalizeOnGoingOperationResponse.getResult --');
    console.log(finalizeOnGoingOperationResponse.getResult());

    if (finalizeOnGoingOperationResponse.ok()) {
      this.terminalStatus = finalizeOnGoingOperationResponse.ok();
      this.paymentInProgess = false;
      this.blockBtnClose = false;
      console.log(finalizeOnGoingOperationResponse);
      this.$emit('payment-finalized');

      this.close();
    } else {
      this.terminalStatus = false;
      this.paymentInProgess = false;
      this.paymentErrorMsg = finalizeOnGoingOperationResponse.getResult().error.msg;
      this.paymentErrorReason = finalizeOnGoingOperationResponse.getResult().error.reason;
      this.paymentErrorData = finalizeOnGoingOperationResponse.getResult().content;
      this.pendingOperation = finalizeOnGoingOperationResponse.getResult().content.operation;
      this.blockBtnClose = false;
      console.log(finalizeOnGoingOperationResponse);
    }
  }

  async finalizePendingOperation() {
    console.log('== finalizePendingOperation ==');
    this.blockBtnClose = true;
    this.initVars();
    clearInterval(this.refreshInterval);
    const cashdroService = new CashdroService();
    const formatedAmount = this.pendingOperation.totalin / 100;
    const finalizePendingOperationResponse = await cashdroService.finalizeOperation(
      this.selectedTerminal,
      this.pendingOperation.operationId,
      this.pendingOperation.posId,
      formatedAmount,
    );
    console.log('-- finalizeOnGoingOperationResponse --');
    console.log(finalizePendingOperationResponse);
    console.log('-- finalizeOnGoingOperationResponse.getResult --');
    console.log(finalizePendingOperationResponse.getResult());

    if (finalizePendingOperationResponse.ok()) {
      this.terminalStatus = finalizePendingOperationResponse.ok();
      this.paymentInProgess = false;
      this.blockBtnClose = false;
      console.log(finalizePendingOperationResponse);
      this.$emit('payment-finalized');

      this.close();
    } else {
      this.terminalStatus = false;
      this.paymentInProgess = false;
      this.paymentErrorMsg = finalizePendingOperationResponse.getResult().error.msg;
      this.paymentErrorReason = finalizePendingOperationResponse.getResult().error.reason;
      this.paymentErrorData = finalizePendingOperationResponse.getResult().content;
      this.pendingOperation = finalizePendingOperationResponse.getResult().content.operation;
      this.blockBtnClose = false;
      console.log(finalizePendingOperationResponse);
    }
  }

  async endOperation() {
    console.log('== endOperation ==');
    this.blockBtnClose = true;
    //this.initVars();

    const cashdroService = new CashdroService();
    const totalIn = parseInt(this.onGoingOperation.totalin);
    const totalOut = parseInt(this.onGoingOperation.totalout);
    //NOTE: totalOut comes in negative.
    const amount = (totalIn - Math.abs(totalOut)) / 100;
    console.log('-- totalIn --');
    console.log(totalIn);
    console.log('-- totalOut --');
    console.log(totalOut);
    console.log('-- amount --');
    console.log(amount);

    const endOperationResponse = await cashdroService.endOperation(
      this.invoiceId,
      this.selectedTerminal,
      this.onGoingOperation.operationId,
      amount,
    );
    console.log('-- endOperationResponse --');
    console.log(endOperationResponse);
    console.log('-- endOperationResponse.getResult --');
    console.log(endOperationResponse.getResult());

    if (endOperationResponse.ok()) {
      this.terminalStatus = endOperationResponse.ok();
      this.paymentInProgess = false;
      this.blockBtnClose = false;
      console.log(endOperationResponse);
      this.$emit('on-success-payment');
      this.close();
    } else {
      this.terminalStatus = false;
      this.paymentInProgess = false;
      this.paymentErrorMsg = endOperationResponse.getResult().error.msg;
      this.paymentErrorReason = endOperationResponse.getResult().error.reason;
      this.paymentErrorData = endOperationResponse.getResult().content;
      this.blockBtnClose = false;
      console.log(endOperationResponse);
    }
  }
  async endPendingOperation() {
    console.log('== endPendingOperation ==');
    this.blockBtnClose = true;
    //this.initVars();

    const cashdroService = new CashdroService();
    const totalIn = parseInt(this.onGoingOperation.totalin);
    const totalOut = parseInt(this.onGoingOperation.totalout);
    //NOTE: totalOut comes in negative.
    const amount = (totalIn - Math.abs(totalOut)) / 100;
    console.log('-- totalIn --');
    console.log(totalIn);
    console.log('-- totalOut --');
    console.log(totalOut);
    console.log('-- amount --');
    console.log(amount);

    const endOperationResponse = await cashdroService.endOperation(
      this.pendingOperation.posId,
      this.selectedTerminal,
      this.pendingOperation.operationId,
      amount,
    );
    console.log('-- endOperationResponse --');
    console.log(endOperationResponse);
    console.log('-- endOperationResponse.getResult --');
    console.log(endOperationResponse.getResult());

    if (endOperationResponse.ok()) {
      this.terminalStatus = endOperationResponse.ok();
      this.paymentInProgess = false;
      this.blockBtnClose = false;
      console.log(endOperationResponse);
      this.$emit('on-success-payment');
      this.close();
    } else {
      this.terminalStatus = false;
      this.paymentInProgess = false;
      this.paymentErrorMsg = endOperationResponse.getResult().error.msg;
      this.paymentErrorReason = endOperationResponse.getResult().error.reason;
      this.paymentErrorData = endOperationResponse.getResult().content;
      this.blockBtnClose = false;
      console.log(endOperationResponse);
    }
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  close() {
    clearInterval(this.refreshInterval);
    this.$emit('click-on-close');
  }
}
